export const environment = {
  endPoint: process.env.NODE_ENV === 'development' ? "https://admin.octopiwellness.com" : "https://admin.octopiwellness.com"
};
